





























import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
// import { State, Getter, Action, Mutation } from 'vuex-class';
import { Debounce } from 'lodash-decorators';

@Component
export default class Cities extends Vue {

    public pagination: any = {
        per_page: 10,
        page: 1,
    }
    public totalItems: any = 1;

    public cities: any[] = [];

    public citiesLoading: boolean = true;

    public dialog: boolean = false;

    public isUpdate: boolean = false;

    public $refs!: {
        form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
    }

    get headersLocalized(): any[] {
        return [
            {
                text: this.$t('table_headers.translated_shared.en.name'),
                value: 'translations.en.name'
            },
            {
                text: this.$t('table_headers.translated_shared.sr.name'),
                value: 'translations.sr.name'
            },
            {
                // text: this.$t('table_headers.abbreviation'),
                text: 'Abbreviation',
                value: 'abbreviation'
            },
        ]
    }

    public close () {
        this.dialog = false;
        this.isUpdate = false;
        this.$refs.form.reset();
    }

    public async loadCities() {

        this.citiesLoading = true;

        let payload = {
            page: this.pagination.page,
            per_page: this.pagination.per_page,
        }
        let response = await axios.get(api.path('v2.admin.cities'), { params: payload });

        this.cities = response.data.data;
        this.totalItems = response.data.meta.total;
        this.citiesLoading = false
    }

    @Watch('pagination', { deep: true })
    @Debounce(500)
    onFilterValueChange( value: any ) {
        this.loadCities();
    }

    public async mounted() {
        
        await this.loadCities();
        
    }

}
